import React, { useEffect, useRef, useState } from 'react';
import { stats } from '../data/mock';

function Counter({ to, suffix = '' }) {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !started.current) {
            started.current = true;
            const duration = 1600;
            const target = parseInt(to, 10);
            const startTime = performance.now();
            const tick = (now) => {
              const p = Math.min((now - startTime) / duration, 1);
              const eased = 1 - Math.pow(1 - p, 3);
              setValue(Math.round(target * eased));
              if (p < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [to]);

  return (
    <span ref={ref} className="tabular-nums">{value}{suffix}</span>
  );
}

export default function Stats() {
  return (
    <section className="relative bg-[#0a1b35] py-16 sm:py-20 border-y border-[#e8b863]/12">
      <div className="absolute inset-0 bg-grid opacity-25" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`text-center lg:text-left ${i < 3 ? 'lg:border-r lg:border-[#e8b863]/18 lg:pr-8' : ''}`}
            >
              <div className="font-serif text-[48px] sm:text-[60px] lg:text-[72px] leading-none font-medium gold-gradient">
                <Counter to={s.value} suffix={s.suffix} />
              </div>
              <p className="text-white/72 text-[12.5px] sm:text-[13px] lg:text-[14px] tracking-wide mt-3 max-w-[220px] mx-auto lg:mx-0">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
